<template>
  <b-modal
    id="modal-sms-template"
    :title="isEdit ? $t('generals.edit') : $t('sms.new_sms_template')"
    centered
    :cancel-title="$t('generals.cancel')"
    size="lg"
    :ok-title="isEdit ? $t('generals.save') : $t('generals.create')"
    @ok="saveClick"
  >
    <b-card-text>
      <b-form-group
        :label="$t('sms.template_name')"
      >
        <b-form-input v-model="smsTemplate.title" />
      </b-form-group>
      <b-form-group
        :label="$t('sms.sms_content')"
        :description="sms_template_fields"
      >
        <b-tabs
          content-class="pt-1"
          fill
        >
          <b-tab
            title="Uz"
          >
            <label for="uz_body">Uz:</label>
            <b-form-textarea
              v-model="smsTemplate.body.uz"
              label="Text input with lazy formatter (on blur)"
              rows="3"
            />
          </b-tab>
          <b-tab
            title="Ru"
          >
            <label for="ru_body">Ru:</label>
            <b-form-textarea
              v-model="smsTemplate.body.ru"
              label="Text input with lazy formatter (on blur)"
              rows="3"
            />
          </b-tab>
        </b-tabs>
      </b-form-group>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BModal, BCardText, BFormGroup, BFormInput, BFormTextarea, BTabs, BTab,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BModal, BCardText, BFormGroup, BFormInput, BFormTextarea, BTabs, BTab,
  },
  props: {
    smsTemplate: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      sms_template_fields: '',
    }
  },
  computed: {
    ...mapGetters('sms', ['GET_MAIL_TEMPLATE_FIELDS', 'GET_SMS_TEMPLATE_FIELDS']),
  },
  mounted() {
    this.FETCH_SMS_TEMPLATE_FIELDS().then(res => {
      console.log(res)
      res.forEach(element => {
        this.sms_template_fields = this.sms_template_fields.concat(`@${element.field_name} - ${element.about}, `)
      })
    })
  },
  methods: {
    ...mapActions('sms', ['ADD_SMS_TEMPLATE', 'EDIT_SMS_TEMPLATE', 'FETCH_SMS_TEMPLATE_FIELDS']),
    saveClick() {
      console.log(this.smsTemplate)
      if (this.isEdit) {
        this.EDIT_SMS_TEMPLATE(this.smsTemplate).then(() => {
          this.$_successToast(this.$t('generals.changed'))
          this.$emit('saveSuccess')
        })
      } else {
        this.ADD_SMS_TEMPLATE(this.smsTemplate).then(() => {
          this.$_successToast(this.$t('generals.added'))
          this.$emit('saveSuccess')
        })
      }
    },
  },
}
</script>

<style>
</style>
